import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import ChangeLogsTable from '../tables/ChangeLogsTable';
import FailedJobsTable from '../tables/FailedJobsTable';
import { tryToFetchFailedRecon, tryToFetchRuleLogs } from '../../../../store/brokers/partners/admin/adminSlice';

const Logs = () => {
    const dispatch = useAppDispatch()
    const [logs, setLogs] = useState<any>([]);
    const [failedLogs, setFailedLogs] = useState<any>([]);
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const [paginationStateFailed, setPaginationStateFailed] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const state = useAppSelector(state => state.admin.logs?.data)
    const paginationData = useAppSelector((state) => state.admin?.logs?.data?.page);
    const paginationDataFailed = useAppSelector((state) => state.admin?.failedRecon?.data?.page);
    const stateFailed = useAppSelector(state => state.admin.failedRecon?.data)

    useEffect(() => {
        if (stateFailed) setFailedLogs(stateFailed?.elements);
    }, [stateFailed]);

    useEffect(() => {
        if (state) setLogs(state?.elements);
    }, [state]);

    const onGettingData = async () => {
        try {
            const settingsFilters = {
                ...paginationState
            }
            await dispatch(tryToFetchRuleLogs(settingsFilters)).unwrap()
        } catch (err) {
            console.error(err)
        }
    }

    const onGettingFailedData = async () => {
        try {
            const settingsFilters = {
                ...paginationStateFailed
            }
            await dispatch(tryToFetchFailedRecon(settingsFilters)).unwrap()
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        onGettingFailedData()
    }, [paginationStateFailed]);

    useEffect(() => {
        onGettingData()
    }, [paginationState]);

    return (
        <div>
            <p className='dark:text-primary-dark mt-10 mb-5'><span className='font-bold text-xl'>Change Logs </span>- Template & Rules Change</p>
            <ChangeLogsTable
                rows={logs}
                paginationData={paginationData}
                paginationState={paginationState}
                setPaginationState={setPaginationState}
            />
            <p className='font-bold dark:text-primary-dark text-xl mt-10 mb-5'>Failed Reconciliation Jobs</p>
            <FailedJobsTable
                rows={failedLogs}
                paginationData={paginationDataFailed}
                paginationState={paginationStateFailed}
                setPaginationState={setPaginationStateFailed}
            />
        </div>
    )
}
export default Logs;